import type { Topic } from '@/types/course';

export const topics: Topic[] = [
  {
    id: 'zero-to-one-programmer',
    title: '零基础转行程序员之路',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20modern%20flat%20illustration%20of%20a%20career%20transition%20into%20programming%20with%20code%20and%20roadmap%20elements%20on%20a%20soft%20light%20gray%20white%20background%2C%20minimal%20professional%20editorial%20poster%2C%20subtle%20blue%20teal%20accents%2C%20high%20detail%20balanced%20composition&width=1200&height=700&seq=topic-programmer-01&orientation=landscape',
    intro: '为想转行进入互联网行业的你，规划一条从零基础到拿到 offer 的清晰学习路线。',
    reason: '精选前端、后端、数据分析与人工智能四个方向的入门课程，配合岗位技能拆解，帮助你找到最适合自己的切入方向，少走弯路。',
    courseIds: ['react-frontend', 'python-backend', 'data-analysis', 'ai-intro'],
    tags: ['转行', '编程', '职业规划'],
  },
  {
    id: 'language-exam-sprint',
    title: '语言考级冲刺计划',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20language%20exam%20preparation%20with%20books%20and%20globe%20on%20a%20soft%20light%20gray%20white%20background%2C%20clean%20professional%20editorial%20poster%2C%20subtle%20warm%20accents%2C%20high%20detail%20harmonious%20composition&width=1200&height=700&seq=topic-language-02&orientation=landscape',
    intro: '雅思、日语、韩语等语言考级一站式冲刺专题，助你在短时间内高效提分。',
    reason: '汇集应试经验丰富的讲师课程，从题型技巧到真题实战逐层突破，适合有明确考期、需要系统提分的同学。',
    courseIds: ['ielts-writing', 'japanese-n5', 'korean-basics', 'english-basics'],
    tags: ['考级', '雅思', '日语'],
  },
  {
    id: 'workplace-competitiveness',
    title: '职场竞争力提升专题',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20modern%20flat%20illustration%20of%20workplace%20skills%20with%20briefcase%20and%20growth%20chart%20on%20a%20soft%20light%20gray%20white%20background%2C%20minimal%20professional%20editorial%20poster%2C%20subtle%20blue%20accents%2C%20high%20detail%20balanced%20composition&width=1200&height=700&seq=topic-career-03&orientation=landscape',
    intro: '办公技能、项目管理与设计能力，多维度打造不可替代的职场竞争力。',
    reason: '从日常效率工具到高阶项目方法论，覆盖你晋升路上最需要的硬技能与通用能力，边学边用，效果可见。',
    courseIds: ['excel-master', 'project-management', 'ui-design', 'video-editing'],
    tags: ['职场', '效率', '晋升'],
  },
  {
    id: 'wealth-management',
    title: '个人财富管理入门专题',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20flat%20illustration%20of%20personal%20wealth%20management%20with%20coins%20and%20growth%20curve%20on%20a%20soft%20light%20gray%20white%20background%2C%20clean%20professional%20editorial%20poster%2C%20subtle%20teal%20accents%2C%20high%20detail%20harmonious%20composition&width=1200&height=700&seq=topic-wealth-04&orientation=landscape',
    intro: '从会计基础到投资理财，建立属于你自己的财务认知体系与资产规划。',
    reason: '理财先理脑，这个专题带你从看懂报表到理解投资逻辑，用正确的框架管理好每一分钱。',
    courseIds: ['stock-invest', 'accounting-basics', 'data-analysis'],
    tags: ['理财', '投资', '财务'],
  },
];